import { c as _c } from "react/compiler-runtime";
import type { Address } from '@morpho-org/blue-sdk';
import { getCdnUrl } from '@morpho-org/dapp-core';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import { abbreviateAddress } from '@repo/utils';
import Image from 'next/image';
import { SafeQuorum } from '@/components/common/SafeQuorum';
interface GuardianLabelProps {
  isAragonDAO?: boolean;
  safeQuorum?: string;
  address?: Address;
  isMissingAddress?: boolean;
  /** text-* class controlling the text variant (default: `text-md`). */
  textClassName?: string;
}
export const GuardianLabel = t0 => {
  const $ = _c(20);
  const {
    isAragonDAO,
    safeQuorum,
    address,
    isMissingAddress,
    textClassName: t1
  } = t0;
  const textClassName = t1 === undefined ? "text-md" : t1;
  if (isAragonDAO) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Image src={getCdnUrl("v2/assets/icons/aragon.svg")} alt="Aragon DAO" width={18} height={18} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== textClassName) {
      t3 = cn(textClassName, "text-foreground");
      $[1] = textClassName;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        whiteSpace: "nowrap"
      };
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t3) {
      t5 = <span className={t3} style={t4}>{"Aragon DAO"}</span>;
      $[4] = t3;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <InfoTooltip disableHoverableContent={false} tooltipContent={<span>Depositor DAO powered by Aragon OSx<ExternalLink href="https://forum.morpho.org/t/trustless-onchain-guardian-setup-for-metamorpho-vaults/530" className="text-secondary-foreground inline-block hover:underline">Learn more →</ExternalLink></span>} />;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t5) {
      t7 = <>{t2}{t5}{t6}</>;
      $[7] = t5;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    return t7;
  }
  if (safeQuorum) {
    let t2;
    if ($[9] !== safeQuorum || $[10] !== textClassName) {
      t2 = <SafeQuorum safeQuorum={safeQuorum} textClassName={textClassName} />;
      $[9] = safeQuorum;
      $[10] = textClassName;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  if (address) {
    let t2;
    if ($[12] !== textClassName) {
      t2 = cn(textClassName, "text-foreground");
      $[12] = textClassName;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t3;
    if ($[14] !== address || $[15] !== isMissingAddress) {
      t3 = isMissingAddress ? "No Address." : abbreviateAddress(address);
      $[14] = address;
      $[15] = isMissingAddress;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[17] !== t2 || $[18] !== t3) {
      t4 = <span className={t2}>{t3}</span>;
      $[17] = t2;
      $[18] = t3;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    return t4;
  }
  return null;
};